/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
import { IntlMessageFormat } from './src/core';
export * from './src/core';
export * from './src/error';
export * from './src/formatters';
export { IntlMessageFormat };
export default IntlMessageFormat;
//# sourceMappingURL=index.js.map